import { z } from 'zod';
import { SortQuerySchema } from '../common';

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function isValidDateOnly(value: string): boolean {
  if (!DATE_ONLY.test(value)) return false;
  const date = new Date(`${value}T00:00:00.000Z`);
  return date.toISOString().slice(0, 10) === value;
}

const dateOnly = z
  .string()
  .regex(DATE_ONLY, 'Date must use YYYY-MM-DD')
  .refine(isValidDateOnly, 'Date is not a valid calendar date');

export const QueryComisionesSchema = z
  .object({
    offset: z.coerce.number().int().min(0).default(0),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    fechaDesde: dateOnly.optional(),
    fechaHasta: dateOnly.optional(),
    userId: z.string().uuid().optional(),
  })
  .merge(SortQuerySchema)
  .strict()
  .refine(
    (value) =>
      value.fechaDesde === undefined ||
      value.fechaHasta === undefined ||
      value.fechaDesde <= value.fechaHasta,
    {
      message: 'fechaDesde must be before or equal to fechaHasta',
      path: ['fechaHasta'],
    },
  );

export type QueryComisiones = z.infer<typeof QueryComisionesSchema>;

/**
 * Export query: date window only. The bulk export intentionally ignores UI
 * pagination/sorting and is never filtered by userId on the wire.
 */
export const ComisionesExportQuerySchema = z
  .object({
    fechaDesde: dateOnly.optional(),
    fechaHasta: dateOnly.optional(),
  })
  .strict()
  .refine(
    (value) =>
      value.fechaDesde === undefined ||
      value.fechaHasta === undefined ||
      value.fechaDesde <= value.fechaHasta,
    {
      message: 'fechaDesde must be before or equal to fechaHasta',
      path: ['fechaHasta'],
    },
  );

export type ComisionesExportQuery = z.infer<typeof ComisionesExportQuerySchema>;

export const ComisionUserParamSchema = z.object({ userId: z.string().uuid() });

export type ComisionUserParam = z.infer<typeof ComisionUserParamSchema>;
